/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import { forwardRef } from "react";

import { spacing } from "../../../../../global/emotion";
import type { HallowElement } from "../../../../types/hallowElement.types";
import type { HallowElementProps } from "../../../../types/hallowElementProps.types";
import type { WithAsChild } from "../../../../types/withAsChild.types";
import { determineElementFromAsChild } from "../../../../utils/determineElementFromAsChild";

const hallowElement: HallowElement = "ul";

const baseStyle: Interpolation = {
  display: "flex",
  flexDirection: "column",
  gap: spacing.s,
};

export type ListProps = WithAsChild<HallowElementProps<typeof hallowElement>>;

export const List = forwardRef<any, ListProps>(
  ({ asChild = false, children, ...props }, ref) => {
    const DeterminedElement = determineElementFromAsChild({
      asChild,
      hallowElement,
    });

    return (
      <DeterminedElement ref={ref} css={baseStyle} {...props}>
        {children}
      </DeterminedElement>
    );
  },
);

List.displayName = "List";
